import { createContext, useContext, useEffect, useState } from "react";
import client from "@/app/client";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = guest, object = authenticated
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("wynn_token");
    if (!token) {
      setUser(false);
      return;
    }
    client
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("wynn_token");
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await client.post("/auth/login", { email, password });
    localStorage.setItem("wynn_token", data.token);
    setUser(data.user);
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await client.post("/auth/register", { name, email, password });
    localStorage.setItem("wynn_token", data.token);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("wynn_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
